// @module NVT.ssg_funded.ssgfunded
define('NVT.ssg_funded.ssgfunded.View'
	, [
		'nvt_ssg_funded_ssgfunded.tpl'

		, 'NVT.MyRegisterColleague.MyRegisterColleague.SS2Model'

		, 'Backbone'

		, 'GlobalViews.Message.View'

		, 'NVT.ssg_funded.ssgfunded.View'

		, 'Profile.Model'

		, 'Utils'

	]
	, function (
		nvt_ssg_funded_ssgfunded_tpl

		, MyRegisterColleagueSS2Model

		, Backbone

		, MessageView

		, ssgfundedView

		, ProfileModel

		, Utils
	) {
		'use strict';
		var doyouwanttoaddmore = false;

		// @class NVT.ssg_funded.ssgfunded.View @extends Backbone.View
		return Backbone.View.extend({

			template: nvt_ssg_funded_ssgfunded_tpl

			, initialize: function (options) {
				this.options = options;
				this.container = options.container;
				this.layout = this.container.getComponent('Layout');
				this.pdp = this.container.getComponent('PDP');
				var self = this;
				self.registrationtype_indivusal = true;
				self.loadingTimeonecs = true;
				self.wizlearn_enrolmnet_jason = '';
			}

			, events: {
				'input [name="organisationindividual"]': 'selectselectCorporate',
				'submit form': 'saveForm',
				'click button[data-action="want-to-add-more-colleague"]': 'wantToAddMoreColleague',
				'click button[data-action="add-new-colleague"]': 'addNewColleague',
				'change [data-action="contact_list"]': 'getContactList',
				'change [data-action="company_contact_list"]': 'ContactListSearching',
				'click [data-action="selectregisterColleagueName"]': 'choiceRegisterColleagueName',
				'click button[data-action="add-new-colleague-wait-list"]': 'addNewColleagueWaitlist',
				'click button[data-action="add-new-colleague-isscrrequire"]': 'addNewColleagueisscrrequire',
				'click label[data-action="itemoption-wise-price"]': 'itemOptionWisePrice',
				'click button[data-action="get-fetch-grant-information"]': 'getFetchGrantInformation',
			}

			, getFetchGrantInformation: function (e) {
				var self = this;
				var get_grant_responce = '';
				var _itemId = self.options.pdp.item.internalid;
				self.parentItemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if (getmultiPriceOption) {
					_itemId = getmultiPriceOption;
				}

				if (jQuery('input[name="nus_phone_no"]').val().trim() == '' || jQuery('input[name="nus_phone_no"]').val().length < 8) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('A phone number is required. Please enter at least 8 digits.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (jQuery('input[name="nus_email_address"]').val() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('The email address used for login is required.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (!Backbone.Validation.patterns.email.test(jQuery('input[name="nus_email_address"]').val())) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('The email address is not correct.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (jQuery('input[name="nric_fin_fp_number"]').val().trim() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter NRIC/FIN/FP Number.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nric_fin_fp_number"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nric_fin_fp_number"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (jQuery('input[name="date_of_birth"]').val() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Date Of Birth.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-date_of_birth"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-date_of_birth"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else {
					if (_itemId != "") {
						const gettoday = new Date().toISOString().split('T')[0];
						var model = new MyRegisterColleagueSS2Model();
						model.fetch({
							async: false, data: {
								"note": "Fetch Grant Information",
								"itemId": _itemId,
								"idType": jQuery('select[name="idtype"]').val(),
								"id": jQuery('input[name="nric_fin_fp_number"]').val(),
								"dateOfBirth": jQuery('input[name="date_of_birth"]').val(),
								"emailAddress": jQuery('input[name="nus_email_address"]').val(),
								"phoneNumber": jQuery('input[name="nus_phone_no"]').val(),
								"fullName": jQuery('input[name="nus_ems_name"]').val(),
								"sponsorshipType": jQuery('select[name="organisationindividual"]').val() == "Organisation" ? "EMPLOYER" : "INDIVIDUAL",
								"sponsoringEmployerUen": jQuery('select[name="organisationindividual"]').val() === 'Individual' ?  self.ssgcompnay_uen : jQuery('input[name="ssgcompnay_uen"]').val(), // non-mandatory
								"modularisedSCTPBundleCourseStartDate": gettoday, // item event start date and non-mandatory
								"contact_fullName": jQuery('select[name="organisationindividual"]').val() == "Organisation" ? jQuery('input[name="contactpersonname"]').val() : '',
								"contact_emailAddress": jQuery('select[name="organisationindividual"]').val() == "Organisation" ? jQuery('input[name="contactpersonemail"]').val() : '',
								"contact_phoneNumber": jQuery('select[name="organisationindividual"]').val() == "Organisation" ? jQuery('input[name="companycontactnumber"]').val().trim() : '',
								'getmethod': 'get_pdp_grant'
							},
						}).done(function (response) {
							if (response.status === "success") {
								var get_databind_tr = '';
								var geteligibleGrants = response.get_responce.data.funding.eligibleGrants || [];
								if (geteligibleGrants && geteligibleGrants.length > 0) {
									geteligibleGrants.forEach((grant, index) => {
										get_databind_tr += `	<tr>
											<td>${grant.schemeName} (${grant.supportingAgency})</td>
											<td class="custom_right_align">  
 											${grant.currencyType} ${grant.amount}
											</td>
										</tr>`;
									});
								}
								var databind = `<table class="table table-bordered table-striped">
								<tbody >
									<tr>
									<td>Approved Course Fee</td>
									<td class="custom_right_align">  
									${response.get_responce.data.funding.approvedCourseFee.currencyType} ${response.get_responce.data.funding.approvedCourseFee.amount}
									</td>
									</tr>

									${get_databind_tr}
								
									<tr>
									<td>Total Funding</td>
									<td class="custom_right_align">
									${response.get_responce.data.funding.totalFunding.currencyType} ${response.get_responce.data.funding.totalFunding.amount}
									</td>
									</tr>
									<tr>
									<td>Net Fee</td>
									<td class="custom_right_align">
									${response.get_responce.data.funding.nettFee.currencyType} ${response.get_responce.data.funding.nettFee.amount}
									</td>
									</tr>
								</tbody>
								</table>`;
								jQuery(".getresponcebind").html(databind);
							}
							else {
								var databind = `<p class="address-card-container backcolorapply"> Error : ${response.get_responce}</p>`;
								jQuery(".getresponcebind").html(databind);
							}
							self.wizlearn_enrolmnet_jason = response.wizlearn_enrolmnet_jason;
						});
					}

					jQuery('[name="modelgranddetails"]').show();
				}
			}

			, selectselectCorporate: function (e) {
				var self = this;
				self.registrationtype = e.currentTarget.value;
				self.registrationtype_indivusal = false;
				self.registrationtype_company = false;

				if (self.registrationtype == 'Individual') {
					self.registrationtype_indivusal = true;
				}
				else {
					self.registrationtype_company = true;
				}

				self.render();
			}

			, itemOptionWisePrice: function (e) {
				var self = this;
				var getmpo = e.currentTarget.dataset.mpo || '';
				if (getmpo) {
					var getfiltervalue = this.getmultiPriceOption.filter(function (price) {
						return price.internalid == getmpo
					})

					if (getfiltervalue && getfiltervalue.length > 0) {
						var convPriceMember = Utils.formatCurrency(getfiltervalue[0].memberprice, '');
						var convPriceNonMember = Utils.formatCurrency(getfiltervalue[0].nonmemberprice, '');

						jQuery("#getpriceLevel1Member").text(convPriceMember);
						jQuery("#getpriceLevel3nonMember").text(convPriceNonMember);
						jQuery(".priceonethree").css("display", "block");
					}
					else {
						jQuery("#getpriceLevel1Member").text('');
						jQuery("#getpriceLevel3nonMember").text('');
						jQuery(".priceonethree").css("display", "none");
					}
				}
			}

			, choiceRegisterColleagueName: function (e) {
				var self = this;
				self.getcurrentindexval = e.currentTarget.value;
				jQuery.each(self.ContactList, function (index, item) {
					item.isSelected = null;
				});
				self.render();
			}

			, getContactList: function (e) {
				var self = this;
				var getid = this.$(e.currentTarget).val();
				if (getid) {
					jQuery.each(self.ContactList, function (index, item) {
						item.isSelected = (item.internalid === getid) ? 'T' : null;
					});

					self.render();
				}
			}

			, wantToAddMoreColleague: function (e) {
				var self = this;

				self.loadingTimeonecs = true;
				doyouwanttoaddmore = true;
				document.getElementsByName("surveyquestionans").value = '';
				jQuery("[data-dismiss=modal]").trigger({ type: "click" });
				setTimeout(function () {
					jQuery(".idptritwobtn").click();
				}, 500);
			}

			, addNewColleague: function (e) {
				if (jQuery('.multiPriceOption').length != 0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined) {
					e.preventDefault();
					const getlay = this.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please select item option'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (this.layout) {

					var modalMessage = new ssgfundedView({ container: this.container, pdp: this.pdp.getItemInfo(), addNewColleague: 'NewColleaguelist', title: 'Register Colleague' });
					modalMessage.modalClass = 'modal-md';
					modalMessage.title = 'SSG - Register Participant';
					this.options.container.layout.showInModal(modalMessage);
					return false;
				}
			}

			, addNewColleagueWaitlist: function (e) {
				if (jQuery('.multiPriceOption').length != 0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined) {
					e.preventDefault();
					const getlay = this.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please select item option'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (this.layout) {

					var modalMessage = new ssgfundedView({ container: this.container, pdp: this.pdp.getItemInfo(), addNewColleague: 'Waitlist', title: 'Join Waitlist' });
					modalMessage.modalClass = 'modal-md';
					modalMessage.title = 'SSG - Join Waitlist';
					this.options.container.layout.showInModal(modalMessage);
					return false;
				}
			}


			, addNewColleagueisscrrequire: function (e) {
				if (jQuery('.multiPriceOption').length != 0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined) {
					e.preventDefault();
					const getlay = this.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please select item option'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-multiPriceOption-message"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}
				else if (this.layout) {
					var getnoneditblecontact = jQuery('input[name="multiPriceOption"]:checked').attr('noneditblecontact');
					getnoneditblecontact = getnoneditblecontact === 'true'

					if (jQuery('.multiPriceOption').length == 0 && jQuery('input[name="multiPriceOption"]:checked').val() == undefined) {
						getnoneditblecontact = this.pdp.getItemInfo().item.custitem_nus_noneditablecontact;
					}

					var modalMessage = new ssgfundedView({ container: this.container, pdp: this.pdp.getItemInfo(), addNewColleague: 'scrrequire', title: 'SCREENING', isgetnoneditblecontact: getnoneditblecontact });
					modalMessage.modalClass = 'modal-md';
					modalMessage.title = 'SSG - SCREENING';
					this.options.container.layout.showInModal(modalMessage);
					return false;
				}
			}

			, saveForm: function (e) {
				var self = this;
				var $form = this.$(e.target)
					, form_data = $form.serializeObject();
				e.preventDefault();
				var getmycomp = jQuery('[name="mysearchCompany"]').val() ? jQuery('[name="mysearchCompany"]').val() : '';
				self.profile = ProfileModel.getInstance();
				self.isperson = self.profile.get('isperson') === true;
				self.getorgID = getmycomp;
				if (form_data.mysearchCompany == '' || getmycomp == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please selected organisation list.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-searchCompany"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-searchCompany"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.contact_list == '' && form_data.registerColleagueName == "2") {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please selected contact list.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-contact_list"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-contact_list"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}


				if (form_data.organisationindividual == 'Organisation' && form_data.ssgcompnay == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Compnay.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-ssgcompnay"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-ssgcompnay"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.organisationindividual == 'Organisation' && form_data.ssgcompnay_uen.trim() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Compnay UEN.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-ssgcompnay_uen"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-ssgcompnay_uen"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.organisationindividual == 'Organisation' && form_data.contactpersonname == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Contact Person Name.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-contactpersonname"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-contactpersonname"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				//if (form_data.organisationindividual == 'Organisation' && form_data.companycontactnumber.trim() == '') {
				if (form_data.organisationindividual === 'Organisation' && (form_data.companycontactnumber.trim() === '' || form_data.companycontactnumber.trim().length < 8)) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('A company contact number is required.Please enter at least 8 digits.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-companycontactnumber"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-companycontactnumber"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.organisationindividual == 'Organisation' && form_data.contactpersonemail == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Contact Person Email.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-contactpersonemail"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-contactpersonemail"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.organisationindividual == 'Organisation' && !Backbone.Validation.patterns.email.test(form_data.contactpersonemail)) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('The email address is not correct.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-contactpersonemail"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-contactpersonemail"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				// if (form_data.organisationindividual == 'Organisation' && form_data.numofparticipant == '') {
				// 	const getlay = self.options.container.layout;
				// 	const global_view_message = new MessageView({
				// 		message: Utils.translate('Please enter Number Of Participants.'),
				// 		type: 'error',
				// 		closable: true
				// 	});

				// 	getlay.$('[data-type="alert-placeholder-message-numofparticipant"]').html(global_view_message.render().$el.html());
				// 	const confirmation_message = getlay.$('[data-type="alert-placeholder-message-numofparticipant"]').css("display", "block");

				// 	setTimeout(function () {
				// 		confirmation_message.fadeOut(3000);
				// 	}, 5000);

				// 	return false;
				// }

				if (form_data.nus_ems_name == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter contact name.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_ems_name"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_ems_name"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.nus_job_title == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter job title.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_job_title"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_job_title"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.nus_phone_no.trim() == '' || form_data.nus_phone_no.length < 8) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('A phone number is required. Please enter at least 8 digits.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_phone_no"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.nus_email_address == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('The email address used for login is required.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (!Backbone.Validation.patterns.email.test(form_data.nus_email_address)) {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('The email address is not correct.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nus_email_address"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.nric_fin_fp_number.trim() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter NRIC/FIN/FP Number.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nric_fin_fp_number"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nric_fin_fp_number"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.date_of_birth == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Date Of Birth.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-date_of_birth"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-date_of_birth"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (form_data.nationality.trim() == '') {
					const getlay = self.options.container.layout;
					const global_view_message = new MessageView({
						message: Utils.translate('Please enter Nationality.'),
						type: 'error',
						closable: true
					});

					getlay.$('[data-type="alert-placeholder-message-nationality"]').html(global_view_message.render().$el.html());
					const confirmation_message = getlay.$('[data-type="alert-placeholder-message-nationality"]').css("display", "block");

					setTimeout(function () {
						confirmation_message.fadeOut(3000);
					}, 5000);

					return false;
				}

				if (self.getAllQuestionList) {
					var surveyquesval = document.getElementsByName("surveyquestionans").value;
					var surveyquesvalInarry = surveyquesval ? Object.keys(surveyquesval) : [];
					var getQuestMandatory = Object.keys(JSON.parse(self.getAllQuestionList).survey.questionslist_ismandatory)
					var getQuestMandatorylength = getQuestMandatory.length
					if (getQuestMandatorylength > 0) {
						var setgetQuestMandatory = [];
						for (var qans in getQuestMandatory) {
							setgetQuestMandatory.push(getQuestMandatory[qans].split('_')[1]);
						}

						surveyquesvalInarry = surveyquesvalInarry.sort();
						setgetQuestMandatory = setgetQuestMandatory.sort();

						var erroglag = true;
						var Newarrsystring = setgetQuestMandatory.filter(function (obj) { return surveyquesvalInarry.indexOf(obj) == -1; });
						Newarrsystring.forEach((element) => {
							console.log(element);
							erroglag = false;
							const getlay = self.options.container.layout;
							const global_view_message = new MessageView({
								message: Utils.translate('This field is required.'),
								type: 'error',
								closable: true
							});

							getlay.$('[data-type="alert-placeholder-message-question-answer-type-set-validation-unique-' + element + '"]').html(global_view_message.render().$el.html());
							const confirmation_message = getlay.$('[data-type="alert-placeholder-message-question-answer-type-set-validation-unique-' + element + '"]').css("display", "block");
							setTimeout(function () {
								confirmation_message.fadeOut(3000);
							}, 5000);
						});

						if (erroglag == false) {
							return erroglag;
						}
					}
				}



				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				self.parentItemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if (getmultiPriceOption) {
					_itemId = getmultiPriceOption;
				}
				self.newitemid = _itemId;
				var lines = cart.getLines();
				var indexed = true;
				lines.then(function (lines,) {
					for (i = 0; i < lines.length; i++) {
						var getitemid = lines[i].item.internalid;
						var getemail = lines[i].options != 0 ? lines[i].options.filter(val => val.cartOptionId == 'custcol_nus_ems_patemail')[0] : '';
						getemail = getemail ? getemail.value.internalid : '';
						if (getitemid == _itemId && getemail == form_data.nus_email_address) {
							indexed = false;
						}
					}
				}).then(function () {
					if (indexed) {
						if (form_data) {
							self.addCompName = jQuery('[name="mysearchCompany"]').val().trim();
							form_data.nus_regstype = self.options.addNewColleague;
							form_data.nus_ems_item = self.newitemid; //self.options.pdp.item.internalid;
							form_data.parentItemId = self.parentItemId;
							form_data.mysearchCompany = self.getorgID;
							if (document.getElementsByName("surveyquestionans").value) {
								form_data.folderid = SC.CONFIGURATION.MyRegisterColleague.pdpquestionfolderidmapping;
								form_data.surveyquestionans = JSON.stringify(Object.values(document.getElementsByName("surveyquestionans").value));
							}

							if ("NewColleaguelist" == self.options.addNewColleague) {
								self.addTicketEventWithoutRecord('', form_data)

								if (self.isduplicateEvent_responce.length > 0) {
									const getlay = self.options.container.layout;
									const global_view_message = new MessageView({
										message: SC.CONFIGURATION.MyRegisterColleague.config || Utils.translate(self.isduplicateEvent_responce[0].retrunMesgError),
										type: 'error',
										closable: true
									});
									getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());

								}
								else if (self.statusflag != true){
									jQuery('[name="modelgranddetails"]').show();
								}
								else {
									window.location.href = SC.ENVIRONMENT.siteSettings.touchpoints.home + SC.ENVIRONMENT.siteSettings.touchpoints.checkout;
								}
							}
							else {

								var model = new MyRegisterColleagueSS2Model();
								model.fetch({
									async: false,
									type: 'POST',
									data: { data: JSON.stringify(form_data) },
								})
									.done(function (response) {
										if (response.errorMessage != '') {
											var errormessage = '';

											if (response.errorMessage && typeof response.errorMessage === 'string') {
												errormessage = response.errorMessage;
											}
											else if (response.errorMessage[0].retrunMesgError && Array.isArray(response.errorMessage)) {
												errormessage = response.errorMessage[0].retrunMesgError;
											}
											else {
												errormessage = SC.CONFIGURATION.MyRegisterColleague.config;
											}
											const getlay = self.options.container.layout;
											const global_view_message = new MessageView({
												message: Utils.translate(errormessage),
												type: 'error',
												closable: true
											});
											getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());

										}
										else if (self.options.addNewColleague == "Waitlist") {
											jQuery(".reg-add-to-disaply").css("display", "none");
											jQuery(".reg-add-to-disaply-multiple-event").css("display", "none");
											jQuery('.class-waitlist-confirmation-message').css('display', 'block');
											jQuery('.waitlisttitle').text(self.options.pdp.item.displayname);
											jQuery('.waitlistname').text(response.nus_ems_name);
											jQuery('.waitlistemail').text(response.nus_email_address);
											jQuery(".waitlisttitleconfirm").text('WAITLIST CONFIRMATION');
											jQuery(".waitlistdetailsheading").text("WAITLIST DETAILS");
											jQuery(".msgfromorg").text("If a ticket becomes available, you will be contacted automatically with further instructions on how to purchase your ticket. No further action is required.");
											jQuery(".logodetails").text('You are on the waitlist!');
										}
										else if (self.options.addNewColleague == "scrrequire") {
											jQuery(".reg-add-to-disaply").css("display", "none");
											jQuery(".reg-add-to-disaply-multiple-event").css("display", "none");
											jQuery('.class-waitlist-confirmation-message').css('display', 'block');
											jQuery('.waitlisttitle').text(self.options.pdp.item.displayname);
											jQuery('.waitlistname').text(response.nus_ems_name);
											jQuery('.waitlistemail').text(response.nus_email_address);
											jQuery(".waitlisttitleconfirm").text('We have received your registration!');
											jQuery(".waitlistdetailsheading").text("REGISTRATION  DETAILS");
											jQuery(".msgfromorg").text("Thank you for your interest. We will inform you of the outcome of your registration once it has been reviewed.");
											jQuery(".logodetails").text('Your Registration is Submitted');


											var $return_header = $('.myregistercolleague-info-card-content').first().collapse('show');
											jQuery('html, body').animate(
												{
													scrollTop: $return_header.offset().top
												},
												500
											);
										}
										else {

										}
									});
							}
						}
					}
					else {
						const getlay = self.options.container.layout;
						const global_view_message = new MessageView({
							message: Utils.translate('You have already selected this event. Please check the cart.'),
							type: 'error',
							closable: true
						});

						getlay.$('[data-type="alert-placeholder-common-message"]').html(global_view_message.render().$el.html());
						const confirmation_message = getlay.$('[data-type="alert-placeholder-common-message"]').css("display", "block");

						setTimeout(function () {
							confirmation_message.fadeOut(3000);
						}, 5000);

						return false;
					}
				});
			}

			, getduplicateEventList: function (_itemId, form_data) {
				var self = this;
				self.isduplicateEvent_responce = [];
				if (_itemId != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							'nus_ems_item': _itemId,
							'contact_list': '', //form_data.contact_list,
							'nus_email_address': form_data.nus_email_address,
							'getmethod': 'getduplicateEventList'
						},
					}).done(function (response) {
						self.isduplicateEvent_responce = response;
					});
				}
			}

			, getDocumentUploadEventId: function (_itemId, form_data) {
				var self = this;
				self.isDocumentUploadEvent_responce = [];
				if (_itemId != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						type: 'POST', async: false, data: {
							'itemid': _itemId,
							'data': '' + JSON.stringify(jQuery(form_data)[0]),
							'folderid': SC.CONFIGURATION.MyRegisterColleague.pdpquestionfolderid,
							'getmethod': 'getDocumentUploadEvent'
						},
					}).done(function (getresponse) {
						self.isDocumentUploadEvent_responce = getresponse;
					});
				}
			}


			, getFetchGrantInformationAddtoCart: function (_itemId, form_data) {
				var self = this;
				self.wizlearn_enrolmnet_jason = '';
				self.getCreateWizlearnLearnerLogId = '';
				self.getdtlsgrantinformation = '';
				const gettoday = new Date().toISOString().split('T')[0];
				var profile = ProfileModel.getInstance();
				var is_loged_in = profile.get('isLoggedIn') === 'T';
				if (!is_loged_in) {
					window.location.reload();
				}
				if (_itemId != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							"note": "add_to_cart",
							"itemId": _itemId,
							"idType": form_data.idtype,
							"id": form_data.nric_fin_fp_number,
							"dateOfBirth": form_data.date_of_birth,
							"emailAddress": form_data.nus_email_address,
							"phoneNumber": form_data.nus_phone_no.trim(),
							"fullName": form_data.nus_ems_name,
							"sponsorshipType": form_data.organisationindividual == "Organisation" ? "EMPLOYER" : "INDIVIDUAL",
							"sponsoringEmployerUen": form_data.organisationindividual == "Organisation" ? form_data.ssgcompnay_uen : self.ssgcompnay_uen, // non-mandatory
							"modularisedSCTPBundleCourseStartDate": gettoday, // item event start date and non-mandatory
							"contact_fullName": form_data.organisationindividual == "Organisation" ? form_data.contactpersonname : '',
							"contact_emailAddress": form_data.organisationindividual == "Organisation" ? form_data.contactpersonemail : '',
							"contact_phoneNumber": form_data.organisationindividual == "Organisation" ? form_data.companycontactnumber.trim() : '',
							'getmethod': 'get_pdp_grant'
						},
					}).done(function (response) {
						self.wizlearn_enrolmnet_jason = response.wizlearn_enrolmnet_jason;
						self.getCreateWizlearnLearnerLogId = response.getCreateWizlearnLearnerLogId;
						self.getdtlsgrantinformation = response.status === "success" ? JSON.stringify(response.get_responce) : '';
						self.statusflag = true;
						// var databind = "";
						// if(response.status === "error"){
						// 	self.statusflag =false;
						// 	databind += `<p class="address-card-container backcolorapply"> 
						// 		Error : ${response.get_responce} </p>`;
						// 		jQuery(".getresponcebind").html(databind);		
						// }
						// if(response.getEnrolmentResponce.get_status_type === 'error'){
						// 	self.statusflag = false;
						// 	databind += `<br> <p class="address-card-container backcolorapply"> 
						// 		Error : ${response.getEnrolmentResponce.get_wizlearnresponse} </p>`;
						// 		jQuery(".getresponcebind").html(databind);
						// }
					});
				}
			}

			, addTicketEventWithoutRecord: function (param, form_data) {
				var self = this;
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if (getmultiPriceOption) {
					_itemId = getmultiPriceOption;
				}

				self.isduplicateEvent_responce_1 = self.getduplicateEventList(_itemId, form_data);
				self.isDocumentUploadEvent_responce_2 = self.getDocumentUploadEventId(_itemId, form_data);
				self.wizlearn_enrolmnet_jason = '';
				self.getCreateWizlearnLearnerLogId = '';
				if (self.options.pdp.item.custitem_nus_wizapitype === "SSG" || self.options.pdp.item.custitem_nus_wizapitype === "Non SSG") {
					self.wizlearn_enrolmnet_jason_responce_3 = self.getFetchGrantInformationAddtoCart(_itemId, form_data);
				}

				if (self.isduplicateEvent_responce.length > 0) {
					return self.isduplicateEvent_responce;
				}
				else if(self.statusflag != true){
					return self.statusflag;
				}
				else {
					if (self.isDocumentUploadEvent_responce.id != '') {
						form_data.surveyquestionans = self.isDocumentUploadEvent_responce.id;
					}
						self.get_ems_cart_ref = self.isDocumentUploadEvent_responce.get_ems_cart_ref ? self.isDocumentUploadEvent_responce.get_ems_cart_ref : form_data; 

					if (self.options.pdp.item.custitem_nus_wizapitype === "SSG" || self.options.pdp.item.custitem_nus_wizapitype === "Non SSG") {
						let removeKeys = ["idtype", "nric_fin_fp_number", "date_of_birth", "nationality", "contactpersonemail", "companycontactnumber", "contactpersonname"];
						let objremoveList = removeKeys.forEach(key => delete form_data[key]);
					}

					var cardEventAdded = cart.addLines({
						lines: [
							{
								quantity: 1,
								options: [
									{ cartOptionId: "custcol_ref_participant_record", value: { internalid: '' } },
									{ cartOptionId: "custcol_event_register_name", value: { internalid: form_data.nus_ems_name } },
									{ cartOptionId: "custcol_nus_ems_patemail", value: { internalid: form_data.nus_email_address } },
									{ cartOptionId: "custcol_nus_partjobtitle", value: { internalid: form_data.nus_job_title } },
									{ cartOptionId: "custcol_nus_partphonno", value: { internalid: form_data.nus_phone_no.trim() } },
									{ cartOptionId: "custcol_nus_ems_participant", value: { internalid: JSON.stringify(self.get_ems_cart_ref) } },
									{ cartOptionId: "custcol_nus_ems_partcomp", value: { internalid: self.addCompName } },
									{ cartOptionId: "custcol_nus_wizlearn_jason", value: { internalid: self.wizlearn_enrolmnet_jason } },
									{ cartOptionId: "custcol_nus_reg_lingrant", value: { internalid: "" + self.getCreateWizlearnLearnerLogId } },
									{ cartOptionId: "custcol_nus_get_approve_grand_inform", value: { internalid: self.getdtlsgrantinformation } }
								],
								item: {
									internalid: _itemId
								}
							},
						]
					}).then(function () {

						self.wizlearn_enrolmnet_jason = '';
						self.getCreateWizlearnLearnerLogId = '';
						self.getdtlsgrantinformation = '';
						// if (self.isperson == true) {
						// 	document.getElementsByName("custom-btn-goto-cart").click();
						// }
					});
				}
			}

			, getIsTicketEvent: function (param) {
				var self = this;
				var cart = self.options.container.getComponent('Cart');
				var _itemId = self.options.pdp.item.internalid;
				var getmultiPriceOption = jQuery('input[name="multiPriceOption"]:checked').val();
				if (getmultiPriceOption) {
					_itemId = getmultiPriceOption;
				}
				var lines = cart.getLines();
				var indexed = false;

				lines.then(function (lines,) {
					for (i = 0; i < lines.length; i++) {
						var getitemid = lines[1].item.internalid;
						var getname = lines[i].options != 0 ? lines[i].options.filter(val => val.cartOptionId == 'custcol_event_register_name')[0] : '';
						getname = getname ? getname.value.internalid : '';

						if (getitemid == _itemId && getname == param) {
							indexed = true;
						}
					}
				}).then(function () {
					if (true) {

					}
				});

				return indexed;
			}

			, searchAndGetListCompany: function (e) {
				var profile = ProfileModel.getInstance();
				var is_loged_in = profile.get('isLoggedIn') === 'T';
				var mult_email = '';
				if (e == undefined) {
					var getsearchkeyword = is_loged_in == true ? profile.get('companyname') : '';
				}
				else {
					e.preventDefault();
					if (this.options.pdp.item.custitem_nus_ems_addguest) {
						var getsearchkeyword = this.$(e.currentTarget).val() || '';
					}
					else {
						var getsearchkeyword = is_loged_in == true ? profile.get('companyname') : '';
					}
				}

				if (is_loged_in == true && profile.get('isperson')) {
					var getsearchkeyword = profile.get('name') || '';
				}

				mult_email = is_loged_in == true ? profile.get('email') : '';
				var loginID = is_loged_in == true ? profile.get('internalid') : '';

				var self = this;
				self.getAllQuestionList = '';
				jQuery('[name="searchCompany"]').empty('');

				if (getsearchkeyword.length > 2) {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							'getsearchkeyword': "" + getsearchkeyword,
							'mult_email': mult_email,
							'loginID': loginID,
							'getmethod': 'companyListSearching'
						}
					})
						.done(function (response) {
							jQuery('[name="searchCompany"]').empty('');
							if (response.length > 0) {
								self.searchCompany = response;
								self.render();
							}
						});
				}
			}

			// one time call
			, ContactListSearching: function (e, param) {
				var self = this;
				self.getsearchkeywordNew = '';
				self.ContactList = [];
				jQuery('[name="contact_list"]').find('option').not(':first').remove();
				if (!param) {
					self.rendertruetime = false;
				}
				self.getsearchkeywordNew = param ? param : jQuery('[name="mysearchCompany"]').val();
				if (self.getsearchkeywordNew != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							'getsearchkeyword': "" + self.getsearchkeywordNew,
							'types': 'company',
							'allowregother': self.options.pdp.item.custitem_nus_ems_regother,
							'allowaddguest': self.options.pdp.item.custitem_nus_ems_addguest,
							'getmethod': 'ContactListSearching',
							"doyouwanttoaddmore": doyouwanttoaddmore
						}
					})
						.done(function (response) {
							if (response) {
								self.ContactList = response;
								jQuery.each(self.searchCompany, function (index, item) {
									item.isSelected = (item.internalid === self.getsearchkeywordNew) ? 'T' : null;
								});
							}

							if (self.rendertruetime) {

							}
							else {
								self.render();
							}
						});
				}
			}

			// one time call
			, get_all_question_list: function (param) {
				var self = this;
				if (param != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							'getsearchkeyword': "" + param,
							'getmethod': 'getAllQuestionListDisplay'
						},
					})
						.done(function (response) {
							self.getAllQuestionList = response;
						});
				}
			}

			// one time call
			, multiPriceOption: function (param) {
				var self = this;
				self.getmultiPriceOption = [];
				var skuname = self.pdp.getItemInfo() ? self.pdp.getItemInfo().item.internalid : '';
				if (skuname != "") {
					var model = new MyRegisterColleagueSS2Model();
					model.fetch({
						async: false, data: {
							'skuname': skuname,
							'getmethod': 'getmultiPriceOption'
						},
					})
						.done(function (response) {
							self.getmultiPriceOption = response;
							this.getmultiPriceOption = response;
						});
				}
			}

			, bindings: {

			}

			, childViews: {

			}

			//@method getContext @return NVT.MyRegisterColleague.MyRegisterColleague.View.Context
			, getContext: function getContext() {
				var self = this;
				const profile = ProfileModel.getInstance();
				const is_loged_in = profile.get('isLoggedIn') === 'T';

				if (is_loged_in) {
					localStorage.removeItem('savedFragment');
				}
				else {
					const fragment = window.location.href;
					localStorage.setItem("savedFragment", fragment);
				}

				self.getContactNamebyselection = [];
				if (is_loged_in && this.inModal) {
					if (self.loadingTimeonecs == true) {
						self.loadingTimeonecs = false;
						self.searchAndGetListCompany();
						self.ContactListSearching('', profile.get('internalid'));
						if (self.options.pdp) {
							self.get_all_question_list(self.options.pdp.item.internalid);
						}
					}

					if (self.ContactList) {
						self.getContactNamebyselection = self.ContactList.filter(function (contact_list) {
							return contact_list.isSelected == 'T'
						});
					}

					if (self.getContactNamebyselection.length > 0) {
						self.getContactName = self.getContactNamebyselection[0].name;
						self.getJobTitle = self.getContactNamebyselection[0].getJobTitle;
						self.getPhoneNo = self.getContactNamebyselection[0].getPhoneNo;
						self.getEmailAddress = self.getContactNamebyselection[0].getEmailAddress;
					}
					else {
						self.getContactName = '';
						self.getJobTitle = '';
						self.getPhoneNo = '';
						self.getEmailAddress = '';
					}
				}



				var response = ''
				if (self.getAllQuestionList) {
					var debugindex = self.getAllQuestionList.lastIndexOf('}') + 1;
					var response = JSON.parse(self.getAllQuestionList.substr(0, debugindex)).survey;
				}

				var getpriceoption = self.multiPriceOption();

				if (self.searchCompany != undefined && self.searchCompany.length > 0) {
					var getselectedCompList = self.searchCompany.filter(function (contact_list) {
						return contact_list.isSelected == 'T'
					});

					if (getselectedCompList.length > 0) {
						self.ssgcompnay = getselectedCompList[0].name;
						self.ssgcompnay_uen = getselectedCompList[0].uen;
					}
				}

				self.registerColleaguetrue = self.getcurrentindexval ? self.getcurrentindexval == '2' ? true : false : true;
				self.registerColleaguefalse = self.getcurrentindexval == '1' ? true : false;
				return {
					questionslist_ismandatory: response ? encodeURIComponent(JSON.stringify(response.questionslist_ismandatory)) : '',
					survey: response,
					isInModal: this.inModal,
					is_loged_in: is_loged_in,
					searchCompanyname: profile.get('companyname') || profile.get('firstname') + ' ' + profile.get('lastname'),
					searchCompanyList: self.searchCompany || [],
					ContactList: self.ContactList || [],
					getContactName: self.getContactName || '',
					getJobTitle: self.getJobTitle || '',
					getPhoneNo: self.getPhoneNo || '',
					getEmailAddress: self.getEmailAddress,
					ems_emsebdate: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_emsebdate : '',
					getpriceLevel1: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel2_formatted : '',
					getpriceLevel2: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel3_formatted : '',
					getpriceLevel3: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel5_formatted : '',
					getpriceLevel4: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.pricelevel12_formatted : '',
					getmultiPriceOption: self.getmultiPriceOption,
					registerColleaguetrue: self.registerColleaguetrue,
					registerColleaguefalse: self.registerColleaguefalse,
					ems_regother: self.options.pdp ? self.options.pdp.item.custitem_nus_ems_regother ? true : false : false,
					ems_addguest: self.options.pdp ? self.options.pdp.item.custitem_nus_ems_addguest || self.options.pdp.item.custitem_nus_ems_regother ? true : false : false,
					isRegistrationclosed: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Approved' ? false : true : false,
					isRegistrationclosedShowJoinWaitlist: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Registration Closed' && this.pdp.getItemInfo().item.custitem_nus_iswaitliston == true ? true : false : false,
					ems_approval_status_ev: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev : '',
					nus_ems_cutmessage: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_cutmessage : '',
					addNewColleagueOption: this.options.addNewColleague == 'Waitlist' ? true : false,
					nus_ems_exteurl: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_exteurl : '',
					nus_iswaitliston: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_iswaitliston : false,
					isbtnshowPTRN: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_approval_status_ev == 'Approved' && this.pdp.getItemInfo().item.custitem_nus_iswaitliston != true ? true : false : false,
					isscrrequire: this.pdp.getItemInfo() ? this.pdp.getItemInfo().item.custitem_nus_ems_scrrequire : false,
					titleName: this.options.title || '',
					ispersonshow: profile.get('isperson') === true,
					isgetnoneditblecontact: self.registerColleaguetrue && self.options.isgetnoneditblecontact === true, //this.options.isgetnoneditblecontact === true,
					modelscrrequire: this.options.addNewColleague == 'scrrequire' ? true : false,
					registrationtype: self.registrationtype === 'Individual',
					registrationtype_indivusal: self.registrationtype_indivusal,
					registrationtype_company: self.registrationtype_company,
					ssgcompnay: self.ssgcompnay || '',
					ssgcompnay_uen: self.ssgcompnay_uen || '',
					getnus_wizapitype: self.options.pdp ? self.options.pdp.item.custitem_nus_wizapitype === "SSG" : false,
				}
			}
		});
	});
